import { ComponentProps, ElementType } from "react";
import { SuggestionResult } from "../pages/SuggestionResult";
import { SuggestionSearchForm } from "../pages/SuggestionSearchForm";
import { SuggestionAppPage } from "../types/enums";

type SuggestionAppPageType = Omit<SuggestionAppPage, SuggestionAppPage.SUGGESTION_FILTER>;

type ComponentType<T extends SuggestionAppPageType> = T extends SuggestionAppPage.SEARCH_SUGGESTION
  ? ElementType<typeof SuggestionSearchForm>
  : T extends SuggestionAppPage.SUGGESTION_RESULT
    ? ElementType<typeof SuggestionResult>
    : ElementType;

type GenericSuggestionAppType<
  C extends ElementType = ComponentType<SuggestionAppPage.SEARCH_SUGGESTION | SuggestionAppPage.SUGGESTION_RESULT>,
> = {
  as: C;
} & ComponentProps<C>;

export default function GenericSuggestionApp<T extends SuggestionAppPageType>({
  as,
  children,
  ...props
}: GenericSuggestionAppType<ComponentType<T>>) {
  const Component = as || "div";

  return <Component {...props}>{children}</Component>;
}
